import type React from "react";
import * as Yup from "yup";
import { ButtonGroupField } from "../../../components/Forms/ButtonGroup";

export const FirmwareUpgradeSubFormSchema = Yup.object().shape({
  format_flag: Yup.boolean(),
  debug_flag: Yup.boolean(),
});

export const FirmwareUpgradeInitialValues = {
  format_flag: false,
  debug_flag: false,
};

export interface FirmwareUpgradeSubFormProps {
  namespace: string;
  disabled?: boolean;
}

const FirmwareUpgradeSubForm: React.FC<FirmwareUpgradeSubFormProps> = ({
  namespace,
  disabled = false,
}) => {
  const withNamespace = (fieldName: string): string => {
    return namespace ? `${namespace}.${fieldName}` : fieldName;
  };

  return (
    <div className="py-4">
      <div>
        <p className="heading-text">Options</p>
      </div>

      <div className="py-4">
        <ButtonGroupField
          fieldName={withNamespace("format_flag")}
          label={{
            label: "Format Flag",
            description: "Enable formatting during firmware upgrade process.",
          }}
          options={[
            { label: "Disabled", value: false },
            { label: "Enabled", value: true },
          ]}
          disabled={disabled}
          fullWidth={true}
        />

        <ButtonGroupField
          fieldName={withNamespace("debug_flag")}
          label={{
            label: "Debug Flag",
            description:
              "Enable debug output during firmware upgrade for troubleshooting.",
          }}
          options={[
            { label: "Disabled", value: false },
            { label: "Enabled", value: true },
          ]}
          disabled={disabled}
          fullWidth={true}
        />
      </div>
    </div>
  );
};

export default FirmwareUpgradeSubForm;
